// extracted by mini-css-extract-plugin
export default {"container":"style_container__t-9ms","bottomInfo":"style_bottomInfo__P5enF"};